import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import { AdminSessionProvider } from './data/useAdminSession';
import { CART_STORAGE_KEY, getCartCount, readCart, writeCart } from './data/cart';
import Home from './pages/Home';
import Product from './pages/Product';
import Checkout from './pages/Checkout';
import Admin from './pages/Admin';

function App() {
  const [cart, setCart] = useState(readCart);
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const cartCount = getCartCount(cart);

  useEffect(() => {
    writeCart(cart);
  }, [cart]);

  useEffect(() => {
    function syncCart(event) {
      if (event.key === CART_STORAGE_KEY) setCart(readCart());
    }
    window.addEventListener('storage', syncCart);
    return () => window.removeEventListener('storage', syncCart);
  }, []);

  function addToCart(product, variant = null) {
    if (product.outOfStock) return;
    setCart((items) => {
      const existing = items.find((item) =>
        item.product.id === product.id && item.variant?.color === variant?.color && item.variant?.size === variant?.size
      );
      if (!existing) return [...items, { product, ...(variant ? { variant } : {}), qty: 1 }];
      return items.map((item) => (item === existing ? { ...item, qty: item.qty + 1 } : item));
    });
  }

  function changeQty(productId, delta, variantColor, variantSize) {
    setCart((items) =>
      items
        .map((item) => (item.product.id === productId && item.variant?.color === variantColor && item.variant?.size === variantSize ? { ...item, qty: item.qty + delta } : item))
        .filter((item) => item.qty > 0)
    );
  }

  function removeFromCart(productId, variantColor, variantSize) {
    setCart((items) => items.filter((item) => !(item.product.id === productId && item.variant?.color === variantColor && item.variant?.size === variantSize)));
  }

  return (
    <AdminSessionProvider>
      <BrowserRouter>
        <Navbar
          cartCount={cartCount}
          searchQuery={searchQuery}
          onSearchChange={(query) => {
            setSearchQuery(query);
            if (query.trim()) setFilter('all');
          }}
          onSelectCategory={setFilter}
        />
        <Routes>
          <Route path="/" element={<Home filter={filter} searchQuery={searchQuery} onFilterChange={setFilter} />} />
          <Route path="/product/:id" element={<Product onAddToCart={addToCart} />} />
          <Route
            path="/checkout"
            element={<Checkout cart={cart} onChangeQty={changeQty} onRemoveItem={removeFromCart} />}
          />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer onSelectCategory={setFilter} />
      </BrowserRouter>
    </AdminSessionProvider>
  );
}

export default App;
